import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setJobHistoryOperation = (state, { jobHistoryOperationData }) => {
  if (!jobHistoryOperationData) return state;
  return state.merge({ jobHistoryOperationData });
};

const setJobHistoryOperationLoaderStatus = (state, { jobHistoryOperationLoader }) => {
  return state.merge({ jobHistoryOperationLoader });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_JOB_HISTORY_OPERATION,
    actionFunction: setJobHistoryOperation,
  },
  {
    actionType: ActionTypes.SET_JOB_HISTORY_OPERATION_LOADER_STATUS,
    actionFunction: setJobHistoryOperationLoaderStatus,
  },
];
